import { updateDesignAction } from '../designerReducer';

export const updateDesign = data => dispatch => {
  dispatch(updateDesignAction(data));
};
